// NFL Guide - Complete Data in Spanish

export const glossaryTerms = [
  { term: "Audible", definition: "Cambio de jugada que el quarterback anuncia en la línea de scrimmage cuando ve la formación defensiva." },
  { term: "Blitz", definition: "Jugada defensiva donde linebackers o defensive backs cargan hacia el quarterback para capturarlo." },
  { term: "Cadena", definition: "Herramienta de medición de 10 yardas que los oficiales usan para determinar si el equipo ofensivo logró un primer down." },
  { term: "Completion", definition: "Pase completado; cuando un receptor atrapa legalmente el balón lanzado por el quarterback." },
  { term: "Down", definition: "Oportunidad o intento que tiene la ofensiva para avanzar el balón. Hay 4 downs para conseguir 10 yardas." },
  { term: "End Zone", definition: "Zona de anotación. Área de 10 yardas en cada extremo del campo donde se anotan los touchdowns." },
  { term: "Fair Catch", definition: "Señal que hace el receptor de un punt o kickoff para no ser tacleado, a cambio de no poder avanzar." },
  { term: "Field Goal", definition: "Gol de campo. Patada a través de los postes que vale 3 puntos." },
  { term: "First Down", definition: "Primer down o 'primer y diez'. Se consigue al avanzar 10 yardas y renueva las 4 oportunidades." },
  { term: "Fumble", definition: "Balón suelto. Ocurre cuando un jugador pierde el balón antes de ser derribado o salir del campo." },
  { term: "Hail Mary", definition: "Pase largo de desesperación, típicamente al final de un partido, lanzado hacia la end zone." },
  { term: "Handoff", definition: "Entrega del balón del quarterback a un corredor para una jugada de carrera." },
  { term: "Holding", definition: "Falta por agarrar ilegalmente a un oponente. Puede ser ofensivo o defensivo." },
  { term: "Huddle", definition: "Reunión de los jugadores antes de cada jugada para recibir la instrucción del quarterback." },
  { term: "Incompletion", definition: "Pase incompleto; cuando el balón toca el suelo o sale fuera de límites sin ser atrapado." },
  { term: "Intercepción", definition: "Cuando un jugador defensivo atrapa un pase destinado a un receptor ofensivo." },
  { term: "Kickoff", definition: "Patada inicial que comienza cada mitad del partido y se realiza después de cada anotación." },
  { term: "Línea de Scrimmage", definition: "Línea imaginaria donde comienza cada jugada, marcada por la posición del balón." },
  { term: "Neutral Zone", definition: "Zona entre las líneas de scrimmage ofensiva y defensiva; solo el centro puede estar en ella antes del snap." },
  { term: "Offside", definition: "Falta cuando un jugador cruza la línea de scrimmage antes del snap." },
  { term: "Pass Interference", definition: "Interferencia de pase. Falta por contacto ilegal con un receptor mientras el balón está en el aire." },
  { term: "Play Action", definition: "Jugada donde el quarterback finge una entrega al corredor antes de lanzar un pase." },
  { term: "Pocket", definition: "Área protegida que forma la línea ofensiva alrededor del quarterback para que pueda lanzar." },
  { term: "Punt", definition: "Despeje. Patada que entrega el balón al equipo contrario, típicamente en cuarto down." },
  { term: "Quarterback", definition: "Mariscal de campo. Líder de la ofensiva que recibe el snap y dirige las jugadas." },
  { term: "Red Zone", definition: "Zona roja. Las últimas 20 yardas antes de la end zone rival." },
  { term: "Rush", definition: "Carrera. Jugada donde un jugador corre con el balón en lugar de lanzarlo." },
  { term: "Sack", definition: "Captura del quarterback detrás de la línea de scrimmage antes de que pueda lanzar." },
  { term: "Safety", definition: "Jugada que vale 2 puntos cuando la defensa derriba al portador del balón en su propia end zone." },
  { term: "Scramble", definition: "Cuando el quarterback corre con el balón porque no encuentra receptores abiertos." },
  { term: "Shotgun", definition: "Formación donde el quarterback se coloca varios pasos detrás del centro para recibir el snap." },
  { term: "Snap", definition: "El momento en que el centro pasa el balón al quarterback para iniciar la jugada." },
  { term: "Tackle", definition: "Placaje. Acción de derribar al portador del balón para terminar la jugada." },
  { term: "Timeout", definition: "Tiempo muerto. Pausa solicitada por un equipo; cada equipo tiene 3 por mitad." },
  { term: "Touchdown", definition: "Anotación principal que vale 6 puntos al llevar el balón a la end zone rival." },
  { term: "Turnover", definition: "Cambio de posesión por intercepción o fumble recuperado por la defensa." },
  { term: "Two-Point Conversion", definition: "Conversión de 2 puntos tras un touchdown, jugada desde la yarda 2." },
  { term: "Wild Card", definition: "Equipos que clasifican a playoffs sin ganar su división; hay 3 por conferencia." },
  { term: "Yard", definition: "Yarda. Unidad de medida del campo; equivale a 0.9144 metros." }
];

export const faqData = [
  {
    question: "¿Cuánto dura un partido de NFL?",
    answer: "Un partido tiene 4 cuartos de 15 minutos de tiempo de juego cada uno, totalizando 60 minutos. Sin embargo, con las pausas, tiempos muertos, revisiones y el espectáculo del medio tiempo, un partido típico dura entre 3 y 3.5 horas."
  },
  {
    question: "¿Por qué paran tanto el juego?",
    answer: "El reloj se detiene por múltiples razones: pases incompletos, jugadores que salen fuera de límites, tiempos muertos, cambios de posesión, revisiones de jugadas, penalizaciones y tiempos publicitarios. Esto permite que las jugadas se planifiquen estratégicamente."
  },
  {
    question: "¿Qué diferencia hay entre la NFL y el fútbol americano universitario?",
    answer: "Ambos comparten reglas similares, pero hay diferencias: en la NFL los jugadores son profesionales, el campo tiene las mismas medidas pero las reglas de recepción y tiempo son ligeramente distintas. La NCAA (universitario) permite más equipos y tiene un sistema de bowls diferente a los playoffs de la NFL."
  },
  {
    question: "¿Cuántos equipos hay en la NFL?",
    answer: "La NFL tiene 32 equipos divididos en 2 conferencias (AFC y NFC) con 4 divisiones cada una (Norte, Sur, Este y Oeste). Cada división tiene 4 equipos."
  },
  {
    question: "¿Cómo funcionan los playoffs?",
    answer: "De los 32 equipos, 14 clasifican a playoffs (7 por conferencia): los 4 campeones de división más 3 comodines (wild cards). Se juegan rondas eliminatorias hasta que quedan 2 equipos que se enfrentan en el Super Bowl."
  },
  {
    question: "¿Qué es el Super Bowl?",
    answer: "Es la final de la NFL, el evento deportivo más visto en Estados Unidos. Se juega el primer domingo de febrero y enfrenta a los campeones de la AFC y NFC. Es famoso tanto por el partido como por el espectáculo del medio tiempo y los costosos anuncios publicitarios."
  },
  {
    question: "¿Cuántos jugadores hay en el campo?",
    answer: "Cada equipo tiene 11 jugadores en el campo a la vez. Como la ofensiva y defensa usan jugadores diferentes, los equipos tienen plantillas de 53 jugadores activos con especialistas para cada situación."
  },
  {
    question: "¿Por qué el quarterback es tan importante?",
    answer: "El quarterback toca el balón en casi todas las jugadas ofensivas, decide si correr, pasar o entregar el balón, lee las defensas y cambia jugadas. Es como el director de orquesta del ataque y su rendimiento influye enormemente en los resultados del equipo."
  },
  {
    question: "¿Qué significa 'primer y diez'?",
    answer: "Significa que es el primer down (primera oportunidad) y el equipo necesita avanzar 10 yardas para renovar sus oportunidades. Si ves '3º y 5', significa tercer down y necesitan 5 yardas."
  },
  {
    question: "¿Por qué a veces patean en cuarto down?",
    answer: "Si no crees que puedas conseguir las yardas necesarias, es mejor patear (punt) para alejar el balón y que el rival empiece más lejos de tu zona de anotación. Si estás cerca de los postes, puedes intentar un field goal de 3 puntos."
  }
];

export const scoringData = [
  {
    type: "Touchdown",
    points: 6,
    description: "Llevar o atrapar el balón dentro de la zona de anotación (end zone) del equipo rival."
  },
  {
    type: "Punto Extra (PAT)",
    points: 1,
    description: "Patada a través de los postes después de un touchdown. Se ejecuta desde la yarda 15."
  },
  {
    type: "Conversión de 2 puntos",
    points: 2,
    description: "Jugada adicional desde la yarda 2 después de un touchdown, en lugar del punto extra."
  },
  {
    type: "Field Goal",
    points: 3,
    description: "Patada a través de los postes en cualquier momento durante una serie ofensiva."
  },
  {
    type: "Safety",
    points: 2,
    description: "Cuando la defensa derriba al portador del balón en su propia zona de anotación."
  }
];

export const positionsData = {
  offense: [
    {
      name: "Quarterback (QB)",
      description: "El líder de la ofensiva. Recibe el snap del centro y decide si lanzar, entregar o correr con el balón. Lee las defensas y cambia jugadas cuando es necesario.",
      qualities: ["Inteligencia táctica", "Precisión de brazo", "Liderazgo", "Visión de campo"],
      color: "#eab308"
    },
    {
      name: "Running Back (RB)",
      description: "El corredor principal. Recibe entregas del quarterback y corre con el balón buscando huecos en la defensa. También puede recibir pases cortos.",
      qualities: ["Velocidad", "Agilidad", "Visión", "Resistencia al contacto"],
      color: "#3b82f6"
    },
    {
      name: "Fullback (FB)",
      description: "Corredor de bloqueo. Su principal función es abrir camino para el running back y proteger al quarterback. Ocasionalmente carga el balón en yardas cortas.",
      qualities: ["Potencia", "Bloqueo", "Sacrificio", "Lectura de jugadas"],
      color: "#3b82f6"
    },
    {
      name: "Wide Receiver (WR)",
      description: "Receptor abierto. Se alinea en los extremos de la formación y corre rutas para recibir pases del quarterback. Necesita velocidad y buenas manos.",
      qualities: ["Velocidad", "Agilidad", "Manos seguras", "Precisión en rutas"],
      color: "#8b5cf6"
    },
    {
      name: "Tight End (TE)",
      description: "Híbrido entre receptor y bloqueador. Se alinea junto a la línea ofensiva y puede tanto bloquear como correr rutas de pase.",
      qualities: ["Versatilidad", "Tamaño", "Bloqueo", "Recepción"],
      color: "#06b6d4"
    },
    {
      name: "Línea Ofensiva (OL)",
      description: "Cinco jugadores (centro, 2 guards, 2 tackles) que protegen al quarterback y abren huecos para las carreras. Son la muralla del equipo.",
      qualities: ["Fuerza", "Técnica de pies", "Comunicación", "Resistencia"],
      color: "#64748b"
    }
  ],
  defense: [
    {
      name: "Defensive End (DE)",
      description: "Extremo defensivo. Se alinea en los bordes de la línea defensiva y persigue al quarterback por el exterior mientras contiene las carreras.",
      qualities: ["Velocidad", "Potencia", "Técnica de manos", "Motor incansable"],
      color: "#ef4444"
    },
    {
      name: "Defensive Tackle (DT)",
      description: "Tackle defensivo. Se alinea en el interior de la línea y su misión es penetrar la línea ofensiva para detener carreras y presionar al QB.",
      qualities: ["Fuerza bruta", "Explosividad", "Resistencia", "Lectura de jugadas"],
      color: "#ef4444"
    },
    {
      name: "Linebacker (LB)",
      description: "Apoyador. Segunda línea de defensa. Detiene carreras, cubre pases cortos y puede cargar al quarterback en blitz.",
      qualities: ["Versatilidad", "Tacleo", "Cobertura", "Instintos"],
      color: "#f97316"
    },
    {
      name: "Cornerback (CB)",
      description: "Esquinero. Cubre a los wide receivers e intenta evitar que atrapen pases. Puede interceptar balones y es crucial en defensa de pase.",
      qualities: ["Velocidad", "Agilidad", "Técnica de cobertura", "Recuperación"],
      color: "#22c55e"
    },
    {
      name: "Safety (S)",
      description: "Última línea defensiva. Ayuda contra carreras largas y protege contra pases profundos. Hay dos tipos: Free Safety (FS) y Strong Safety (SS).",
      qualities: ["Visión de campo", "Tacleo", "Velocidad", "Comunicación"],
      color: "#22c55e"
    }
  ],
  specialTeams: [
    {
      name: "Kicker (K)",
      description: "Pateador. Responsable de kickoffs, field goals y puntos extra. Un kicker preciso puede ser la diferencia en partidos cerrados.",
      qualities: ["Precisión", "Potencia de pierna", "Nervios de acero", "Consistencia"],
      color: "#a855f7"
    },
    {
      name: "Punter (P)",
      description: "Despejador. Patea el balón cuando el equipo decide no intentar convertir en cuarto down. Busca maximizar distancia y hang time.",
      qualities: ["Potencia", "Precisión direccional", "Tiempo de vuelo", "Clutch"],
      color: "#a855f7"
    },
    {
      name: "Long Snapper (LS)",
      description: "Especialista en snaps largos. Envía el balón al holder o punter. Aunque poco reconocido, un mal snap puede costar partidos.",
      qualities: ["Precisión", "Consistencia", "Velocidad de snap", "Fiabilidad"],
      color: "#a855f7"
    },
    {
      name: "Kick/Punt Returner",
      description: "Retornador. Recibe kickoffs y punts e intenta avanzar lo máximo posible. Los mejores pueden cambiar partidos con retornos para touchdown.",
      qualities: ["Velocidad explosiva", "Visión", "Valentía", "Elusividad"],
      color: "#a855f7"
    }
  ]
};

export const formationsData = {
  offense: [
    {
      name: "I-Formation",
      description: "Formación clásica de carrera. El fullback se alinea delante del running back, creando poder para carreras por el centro.",
      players: [
        { position: "C", x: 50, y: 65 },
        { position: "LG", x: 40, y: 65 },
        { position: "RG", x: 60, y: 65 },
        { position: "LT", x: 30, y: 65 },
        { position: "RT", x: 70, y: 65 },
        { position: "QB", x: 50, y: 55, isQB: true },
        { position: "FB", x: 50, y: 45 },
        { position: "RB", x: 50, y: 35 },
        { position: "WR", x: 10, y: 65 },
        { position: "WR", x: 90, y: 65 },
        { position: "TE", x: 80, y: 65 }
      ]
    },
    {
      name: "Shotgun",
      description: "El QB se sitúa 5-7 yardas detrás del centro. Ideal para jugadas de pase porque da más tiempo de reacción.",
      players: [
        { position: "C", x: 50, y: 65 },
        { position: "LG", x: 40, y: 65 },
        { position: "RG", x: 60, y: 65 },
        { position: "LT", x: 30, y: 65 },
        { position: "RT", x: 70, y: 65 },
        { position: "QB", x: 50, y: 45, isQB: true },
        { position: "RB", x: 40, y: 45 },
        { position: "WR", x: 5, y: 65 },
        { position: "WR", x: 95, y: 65 },
        { position: "WR", x: 15, y: 55 },
        { position: "TE", x: 80, y: 65 }
      ]
    },
    {
      name: "Empty Set",
      description: "Sin corredores en el backfield. Cinco receptores elegibles. Formación de pase máximo, muy agresiva.",
      players: [
        { position: "C", x: 50, y: 65 },
        { position: "LG", x: 40, y: 65 },
        { position: "RG", x: 60, y: 65 },
        { position: "LT", x: 30, y: 65 },
        { position: "RT", x: 70, y: 65 },
        { position: "QB", x: 50, y: 50, isQB: true },
        { position: "WR", x: 5, y: 65 },
        { position: "WR", x: 95, y: 65 },
        { position: "WR", x: 15, y: 55 },
        { position: "WR", x: 85, y: 55 },
        { position: "TE", x: 80, y: 65 }
      ]
    }
  ],
  defense: [
    {
      name: "4-3 Defense",
      description: "4 linieros, 3 linebackers. Defensa equilibrada que funciona bien contra carrera y pase.",
      players: [
        { position: "DE", x: 25, y: 65, isDef: true },
        { position: "DT", x: 40, y: 65, isDef: true },
        { position: "DT", x: 60, y: 65, isDef: true },
        { position: "DE", x: 75, y: 65, isDef: true },
        { position: "LB", x: 30, y: 50, isDef: true },
        { position: "LB", x: 50, y: 50, isDef: true },
        { position: "LB", x: 70, y: 50, isDef: true },
        { position: "CB", x: 10, y: 55, isDef: true },
        { position: "CB", x: 90, y: 55, isDef: true },
        { position: "SS", x: 35, y: 35, isDef: true },
        { position: "FS", x: 65, y: 30, isDef: true }
      ]
    },
    {
      name: "3-4 Defense",
      description: "3 linieros, 4 linebackers. Más versátil para blitz y coberturas, pero requiere un nose tackle dominante.",
      players: [
        { position: "DE", x: 30, y: 65, isDef: true },
        { position: "NT", x: 50, y: 65, isDef: true },
        { position: "DE", x: 70, y: 65, isDef: true },
        { position: "OLB", x: 20, y: 55, isDef: true },
        { position: "ILB", x: 40, y: 50, isDef: true },
        { position: "ILB", x: 60, y: 50, isDef: true },
        { position: "OLB", x: 80, y: 55, isDef: true },
        { position: "CB", x: 10, y: 50, isDef: true },
        { position: "CB", x: 90, y: 50, isDef: true },
        { position: "SS", x: 35, y: 35, isDef: true },
        { position: "FS", x: 65, y: 30, isDef: true }
      ]
    },
    {
      name: "Nickel Defense",
      description: "5 defensive backs. Se usa contra formaciones de 3+ receptores. Sacrifica un linebacker por un CB extra.",
      players: [
        { position: "DE", x: 30, y: 65, isDef: true },
        { position: "DT", x: 50, y: 65, isDef: true },
        { position: "DE", x: 70, y: 65, isDef: true },
        { position: "LB", x: 40, y: 50, isDef: true },
        { position: "LB", x: 60, y: 50, isDef: true },
        { position: "CB", x: 5, y: 55, isDef: true },
        { position: "CB", x: 95, y: 55, isDef: true },
        { position: "NCB", x: 25, y: 45, isDef: true },
        { position: "SS", x: 50, y: 35, isDef: true },
        { position: "FS", x: 75, y: 30, isDef: true }
      ]
    }
  ]
};

export const statsExplanation = {
  traditional: [
    {
      category: "Quarterback",
      stats: [
        { name: "Passer Rating", description: "Fórmula que combina completaciones, yardas, touchdowns e intercepciones. Máximo: 158.3" },
        { name: "Completion %", description: "Porcentaje de pases completados sobre intentados" },
        { name: "Passing Yards", description: "Total de yardas ganadas mediante pases completados" },
        { name: "TD/INT Ratio", description: "Relación entre touchdowns lanzados e intercepciones" }
      ]
    },
    {
      category: "Running Back",
      stats: [
        { name: "Rushing Yards", description: "Total de yardas ganadas corriendo con el balón" },
        { name: "YPC (Yards Per Carry)", description: "Promedio de yardas por intento de carrera" },
        { name: "Rushing TDs", description: "Touchdowns anotados corriendo" },
        { name: "Fumbles", description: "Veces que perdió el balón" }
      ]
    },
    {
      category: "Wide Receiver",
      stats: [
        { name: "Receptions", description: "Número de pases atrapados" },
        { name: "Receiving Yards", description: "Yardas totales después de la recepción" },
        { name: "YPR (Yards Per Reception)", description: "Promedio de yardas por recepción" },
        { name: "Targets", description: "Veces que el QB le lanzó el balón" }
      ]
    },
    {
      category: "Defensa",
      stats: [
        { name: "Tackles", description: "Placajes realizados" },
        { name: "Sacks", description: "Capturas del quarterback detrás de la línea" },
        { name: "Interceptions", description: "Pases rivales interceptados" },
        { name: "Pass Deflections", description: "Pases desviados que evitaron completaciones" }
      ]
    }
  ],
  advanced: [
    {
      name: "EPA (Expected Points Added)",
      description: "Mide cuántos puntos esperados añade cada jugada sobre el promedio. Positivo = buena jugada, negativo = mala jugada."
    },
    {
      name: "CPOE (Completion % Over Expected)",
      description: "Diferencia entre el porcentaje de completaciones real y el esperado según la dificultad de los pases."
    },
    {
      name: "Separation",
      description: "Distancia promedio entre el receptor y el defensor más cercano en el momento de la recepción."
    },
    {
      name: "Time to Throw",
      description: "Tiempo promedio que el QB retiene el balón desde el snap hasta el lanzamiento."
    },
    {
      name: "Pressure Rate",
      description: "Porcentaje de dropbacks donde el QB es presionado por la defensa."
    },
    {
      name: "Air Yards",
      description: "Yardas que el balón viaja en el aire antes de ser atrapado (o no)."
    },
    {
      name: "YAC (Yards After Catch)",
      description: "Yardas ganadas por el receptor después de atrapar el balón."
    },
    {
      name: "Win Rate",
      description: "Para linieros: porcentaje de bloqueos o rushes ganados en los primeros 2.5 segundos."
    }
  ]
};

export const nflTeams = {
  AFC: {
    North: ["Baltimore Ravens", "Cincinnati Bengals", "Cleveland Browns", "Pittsburgh Steelers"],
    South: ["Houston Texans", "Indianapolis Colts", "Jacksonville Jaguars", "Tennessee Titans"],
    East: ["Buffalo Bills", "Miami Dolphins", "New England Patriots", "New York Jets"],
    West: ["Denver Broncos", "Kansas City Chiefs", "Las Vegas Raiders", "Los Angeles Chargers"]
  },
  NFC: {
    North: ["Chicago Bears", "Detroit Lions", "Green Bay Packers", "Minnesota Vikings"],
    South: ["Atlanta Falcons", "Carolina Panthers", "New Orleans Saints", "Tampa Bay Buccaneers"],
    East: ["Dallas Cowboys", "New York Giants", "Philadelphia Eagles", "Washington Commanders"],
    West: ["Arizona Cardinals", "Los Angeles Rams", "San Francisco 49ers", "Seattle Seahawks"]
  }
};
